import axios from 'axios'

export const getAddress = (type) => {
  return axios.get(`address/type/${type}`)
    .then(res => res)
    .catch(err => {
      console.log('err', err, err.response)
      throw err.response
    })
}

export const addAddress = (data) => {
  return axios.post('address', data)
    .then(res => {
      return res
    })
    .catch(err => {
      console.log('err', err, err.response)
      throw err.response
    })
}

export const editAddress = payload => axios.put('address', payload)
  .then(res => res)
  .catch((err) => {
    throw err.response
  })

export const deleteAddress = (id) => axios.delete(`address/${id}`)
  .then(res => {
    return res
  })
  .catch(err => {
    console.log('err', err, err.response)
    throw err.response
  })

export const getAllAddressVerivied = (page, perpage) => axios.get(`setting/address/verified/${page}/${perpage}`)
  .then(res => res)
  .catch(err => {
    console.log('err', err, err.response)
    throw err.response
  })

export const getAllAddressVeriviedFilter = (page, filter, key, perpage) => axios.get(`setting/address/verified/filter/${page}/${filter}/${key}/${perpage}`)
  .then(res => res)
  .catch(err => {
    console.log('err', err, err.response)
    throw err.response
  })

export const getAllAddress = (page, perpage) => axios.get(`setting/address/${page}/${perpage}`)
  .then(res => res)
  .catch(err => {
    console.log('err', err, err.response)
    throw err.response
  })

export const getAllAddressFilter = (page, filter, key, perpage) => axios.get(`setting/address/filter/${page}/${filter}/${key}/${perpage}`)
  .then(res => res)
  .catch(err => {
    console.log('err', err, err.response)
    throw err.response
  })

export const addMoreAddress = (payload) => axios.post('setting/address', payload)
  .then(res => res)
  .catch(err => {
    console.log('err', err, err.response)
    throw err.response
  })
export const getBillingAddress = () => axios.get(`setting/address/billing`)
  .then(res => res)
  .catch(err => {
    console.log('err', err, err.response)
    throw err.response
  })

export const removeAddress = (id) => axios.put(`setting/address/deletion/${id}`)
  .then(res => res)
  .catch(err => {
    console.log('err', err, err.response)
    throw err.response
  })

export const setAsBillingAddress = (id) => axios.put(`setting/address/billing/${id}`)
  .then(res => res)
  .catch(err => {
    console.log('err', err, err.response)
    throw err.response
  })

export const editMyAddress = ({data, id}) => axios.put(`setting/address/${id}`, data)
  .then(res => res)
  .catch(err => {
    console.log('err', err, err.response)
    throw err.response
  })

export const fetchShipperSearchAddress = (payload) => {
  return axios.get(`address/search/shipper?keyword=${payload}`)
    .then(res => res)
    .catch(err => {
      console.log('err', err, err.response)
      throw err.response
    })
}

export const fetchConsigneeSearchAddress = (payload) => {
  return axios.get(`address/search/consignee?keyword=${payload}`)
    .then(res => res)
    .catch(err => {
      console.log('err', err, err.response)
      throw err.response
    })
}



// WEBPACK FOOTER //
// ./src/api/address.api.js